import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyBanner() {
  return <section className="w-full px-4 py-16 md:py-20 bg-orange" data-id="element-335">
      <div className="max-w-5xl mx-auto" data-id="element-336">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-337">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-8" data-id="element-338">
            ⏰ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO
          </h2>

          <CountdownTimer data-id="element-339" />

          <div className="mt-8 inline-block px-6 py-3 bg-red-600 rounded-full text-white font-bold" data-id="element-340">
            🔴 Precio sube cuando termina el contador
          </div>
        </motion.div>
      </div>
    </section>;
}